module.exports = __webpack_public_path__ + "img/18-brownlow-avenue-logo.7727be3e.svg";